<template>
  <div class="smart">
    <!-- banner部分 -->
    <div class="smart-banner clearfix">
      <div>
        <h2>智慧工地</h2>
        <h3>智慧工地解决方案</h3>
      </div>
    </div>
    <!-- 方案概述 -->
    <div class="container clearfix">
      <div class="smart-title">方案概述</div>
      <div class="smart-overview mb100">
        <!-- <div class="fl">
          <img src="../../../assets/img/smart/zhdp_summary_Image.png" alt="" />
        </div> -->
        <div>
          <h2>智慧工地解决方案</h2>
          <p>
            斐宸“互联网+”智慧工地，是将互联网+的理念和技术引入建筑工地，从施工现场源头抓起，最大程度的收集人员、安全、环境、材料等关键业务 数据，依托物联网、互联网，建立云端大数据管理平台，形成“端+云+大数据”的业务体系和新的管理模式，打通从一线操作与远程监管的数据链条，
            实现劳务、安全、环境、材料各业务环节的智能化、互联网化管理，提升建筑工地的精益生产管理水平。实现“互联网+”与建筑工地的跨界融合，促进 行业转型升级。
          </p>
        </div>
      </div>
    </div>
    <!-- 方案优势 -->
    <div class="container clearfix">
      <div class="smart-title">方案优势</div>
      <ul class="smart-strength clearfix">
        <li>
          <h2>高空全景视角</h2>
          <p>大视角、超高清</p>
        </li>
        <li>
          <h2>视频点位标签</h2>
          <p>自定义关联标签</p>
        </li>
        <li>
          <h2>实时画中画</h2>
          <p>多路视频叠加</p>
        </li>
        <li>
          <h2>结合地图资源</h2>
          <p>简便、直观</p>
        </li>
        <li>
          <h2>场景联动</h2>
          <p>高速切换</p>
        </li>
        <li>
          <h2>智能分析</h2>
          <p>人、车、物、行为</p>
        </li>
        <li>
          <h2>布控报警</h2>
          <p>视频联动</p>
        </li>
      </ul>
    </div>
    <!-- 方案架构 -->
    <div class="container clearfix">
      <div class="smart-title">方案架构</div>
      <div class="smart-schema">
        <img src="../../../assets/img/solution/framework_Image.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ScintelligentScreen',
};
</script>
<style scoped>
.smart-banner {
  width: 100%;
  height: 594px;
  background: #000;
}
.smart-banner div {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url(../../../assets/img/solution/background_Image_build.png) no-repeat;
  background-size: cover;
}
.smart-banner h2 {
  margin-top: 182px;
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.smart-banner h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}
.smart-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview h2 {
  text-align: center;
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
.smart-strength {
  display: table;
  margin-right: -132px;
}
.smart-strength li {
  float: left;
  width: 366px;
  height: 160px;
  margin-right: 41px;
  margin-bottom: 50px;
}
.smart-strength li h2 {
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.smart-strength li p {
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 1.6;
}
</style>
